export const TYPE_NONE = 0;
export const TYPE_DESIGNATE = 1;
export const TYPE_COURSE = 2;
export const TYPE_PROLONG = 3;
export const TYPE_EVENT = 4;
export const TYPE_DISCOUNT = 5;
export const TYPE_OPTION = 6;
export const TYPE_HOTEL = 7;
//export const TYPE_HOTELROOM = 8;
export const TYPE_TRNSPORT = 9;
export const TYPE_WAITING = 10;
export const TYPE_PLAYROOM = 11;
export const TYPE_PAYMETHOD = 12;
export const TYPE_SPECIAL = 13;
export const TYPE_BURDEN = 14;
export const TYPE_MEDIA = 15;
export const TYPE_ADDITIONAL_PRICE = 16;
// 旧名称。保存済み設定との互換性のため数値は変更しない。
export const TYPE_MEMBERSHIP = TYPE_ADDITIONAL_PRICE;

export const ADDITIONAL_PRICE_MEMBERSHIP = '1';
export const ADDITIONAL_PRICE_ADVANCE = '2';
export const ADDITIONAL_PRICE_OTHER1 = '101';
export const ADDITIONAL_PRICE_OTHER2 = '102';

export const VIEWTYPE_SELECT = 1;
export const VIEWTYPE_SELECT_EDIT = 2;
export const VIEWTYPE_CHECKBOX = 3;
export const VIEWTYPE_CHECKBOX_NUM = 4;
export const VIEWTYPE_TEXT = 5;
export const VIEWTYPE_URL = 11;
export const VIEWTYPE_DATE = 12;
export const VIEWTYPE_TIME = 13;
export const VIEWTYPE_DATETIME = 14;
export const VIEWTYPE_NUMERIC = 15;
export const VIEWTYPE_NUMERIC_POSITIVE = 16;
export const VIEWTYPE_NUMERIC_PRICE = 17;
export const VIEWTYPE_NUMERIC_PAY = 18;
export const VIEWTYPE_SELECT_HIME = 31;
export const VIEWTYPE_SELECT_HIME_WORKING = 32;
export const VIEWTYPE_SELECT_STAFF = 33;
export const VIEWTYPE_SELECT_DRIVER = 34;
export const VIEWTYPE_SELECT_STAFF_OR_DRIVER = 35;
export const VIEWTYPE_SELECT_MEDIA = 36;

export const PROPS_EMPTYACCEPT = 0;
export const PROPS_TARGETCARDFEE = 1;
export const PROPS_TARGETPOINT = 2;
export const PROPS_EMPTYNONE = 3;

export const DESIGNATE_FREE = '0';
export const DESIGNATE_HON = '1';
export const DESIGNATE_HIME = '5';
export const DESIGNATE_PHOTO = '2';
export const DESIGNATE_NET = '3';
export const DESIGNATE_MISC = '4';
export const DESIGNATE_MISC2 = '6';
export const DESIGNATE_HON_NET = '7';
export const DESIGNATE_HON_NET_HIME = '8';
export const DESIGNATE_HON_HIME = '9';
export const DESIGNATE_NET_HIME = '10';

export const PAYMETHOD_CASH = '0';
export const PAYMETHOD_CARD = '1';
export const PAYMETHOD_ELECTRONIC = '2';
